export default [
  {
    position: "absolute",
    top: 0.75,
    left: 25.5,
    class: "dialog",
    animation: "pulsing",
    modalClass: "modal-top-left",
    isDialog: true,
    isAction: true,
    modal: false,
    mTitle: "homeDashboard.persona1.mTitleOne",
    mBody: "homeDashboard.persona1.mBodyOne",
    id: "OB_Homepage_Action_UniqueBranding",
    plusIcon: true,
    index: 0
  },
  {
    position: "absolute",
    top: 17.5,
    left: 12.6,
    class: "dialog",
    animation: "pulsing",
    modalClass: "modal-top-left",
    isDialog: true,
    modal: false,
    mTitle: "homeDashboard.persona1.mTitleTwo",
    mBody: "homeDashboard.persona1.mBodyTwo",
    id: "OB_Homepage_Info_CustomizableLayout",
    infoIcon: true,
    isAction: false,
    index: 1
  },
  {
    position: "absolute",
    top: 5.8,
    left: 52.2,
    class: "dialog",
    animation: "pulsing",
    modalClass: "modal-top-right",
    isDialog: true,
    modal: false,
    mTitle: "homeDashboard.persona1.mTitleThree",
    mBody: "homeDashboard.persona1.mBodyThree",
    id: "OB_Homepage_Info_Learning",
    infoIcon: true,
    isAction: false,
    index: 2
  },
  {
    position: "absolute",
    top: 17.5,
    left: 33,
    class: "dialog",
    animation: "pulsing",
    modalClass: "modal-top-left",
    isDialog: true,
    modal: false,
    mTitle: "homeDashboard.persona1.mTitleFour",
    mBody: "homeDashboard.persona1.mBodyFour",
    infoIcon: true,
    id: "OB_Homepage_Info_News",
    isAction: false,
    index: 3
  },
  {
    position: "absolute",
    top: 6,
    left: 32.2,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 1,
    tooltipText: "homeDashboard.persona1.ttTextOne",
    hover: false,
    id: "OB_Homepage_Navigation_PersonalDetails",
    index: 4
  },
  {
    position: "absolute",
    top: 6,
    left: 60.2,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 4,
    tooltipText: "homeDashboard.persona1.ttTextTwo",
    hover: false,
    id: "OB_Homepage_Navigation_Policies",
    index: 5
  },
  {
    position: "absolute",
    top: 6,
    left: 69.1,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 5,
    tooltipText: "homeDashboard.persona1.ttTextThree",
    hover: false,
    id: "OB_Homepage_Navigation_Feedback",
    index: 6
  },
  {
    position: "absolute",
    top: 0.75,
    left: 87,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 8,
    tooltipText: "homeDashboard.persona1.ttTextFour",
    hover: false,
    tooltipClass: "left",
    id: "OB_Homepage_Navigation_Actions",
    index: 7
  },
  {
    position: "absolute",
    top: 48.4,
    left: 89,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 7,
    tooltipText: "homeDashboard.persona1.ttTextFive",
    hover: false,
    tooltipClass: "left",
    id: "OB_Homepage_Navigation_FirstDay",
    index: 8
  },
];
